export default __webpack_public_path__ + "static/media/signInEn.6cf6dddd.jpg";